import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import { AntdSelect } from '../AntdSelect';
import { useAllGroupList } from './hooks';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { Group } from './types';

import style from './index.module.scss';

import { CommonDependency } from '@/dependency';

const { Option } = AntdSelect;

type Props = {
  name: string;
  className?: string;
  control: Control<FieldValues, object>;
  disabled?: boolean;
  inputWidth?: number;
  placeholder?: string;
  width?: number;
};

const GroupOption = ({ group }: { group: Group }) => {
  const GroupAvatar = CommonDependency.components.GroupAvatar;

  return (
    <div className={style.optionContainer}>
      <GroupAvatar data={group} size={28} />
      <span className={style.badgeName}>{group.name}</span>
    </div>
  );
};

export const GroupSelect = (props: Props) => {
  const { t } = useTranslation();

  const { name, control, disabled, width } = props;
  const { data, isFetched } = useAllGroupList();

  const emptyContent = useMemo(
    () => <div className={style.empty}>{t('GroupSelect.1m47zc6')}</div>,
    [t],
  );

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const isValidValue = isFetched && data?.find(i => i.id === field.value);
        const onChange = value => {
          field.onChange(value);
        };
        return (
          <AntdSelect
            className={style.select}
            dropdownClassName={style.dropdown}
            value={isValidValue ? Number(field.value) : undefined}
            onChange={onChange}
            disabled={disabled}
            showSearch
            style={{width: width ? `${width}px` : undefined}}
            notFoundContent={emptyContent}
            filterOption={(input, option) =>
              (option?.props?.label as string)?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0
            }>
            {data?.map(i => (
              <Option key={`${i.id}`} value={i.id} label={`${i.name}`}>
                <GroupOption group={i} />
              </Option>
            )) || []}
          </AntdSelect>
        );
      }}
    />
  );
};
